import React from 'react';

import type { Section, SettingsGroup } from '@ekhodealer/ekho-common';

import { useServiceProgramInfo } from '../../hooks/useServiceProgramInfo';

export interface ParentSectionProps {
	sectionPath: {
		group: SettingsGroup;
		section: Section;
	};
	title: string;
	description?: string;
	children?: React.ReactNode;
	hideDivider?: boolean;
}

/**
 * ParentSection component - represents a parent section that contains child FormSections.
 * The parent title is shown in the tab; children render their own SettingsSection layout.
 * Visibility is controlled by useServiceProgramInfo.
 */
export function ParentSection({ sectionPath, children }: ParentSectionProps) {
	const programInfo = useServiceProgramInfo(sectionPath.section);

	if (!programInfo.shouldRender) {
		return null;
	}

	return <>{children}</>;
}
